import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import {
  SET_FILTERING_ELEMENT_DISABLED,
  CHANGE_RADIO_GROUP_TEXT,
  CHANGE_SLIDER_MODEL_VALUE,
  SET_FILTERING_STATE_TO_DEFAULT,
  SET_SLIDER_FILTERING_DISABLED,
  SET_RADIOGROUP_FILTERING_DISABLED
} from '@/store/constants/mutation-types';
@Module({ namespaced: true, name: 'MarkersFilteringModule' })
export default class MarkersFilteringModule extends VuexModule {
  public radioGroupElementDisabled = true;
  public sliderElementDisabled = true;
  private radioGroup = '';
  private sliderModel = 0;

  @Mutation
  public [SET_SLIDER_FILTERING_DISABLED](value: boolean) {
    this.sliderElementDisabled = value;
  }

  @Mutation
  public [SET_FILTERING_ELEMENT_DISABLED](value: boolean) {
    this.sliderElementDisabled = value;
    this.radioGroupElementDisabled = value;
  }

  @Mutation
  public [SET_RADIOGROUP_FILTERING_DISABLED](value: boolean) {
    this.radioGroupElementDisabled = value;
  }

  @Mutation
  public [CHANGE_RADIO_GROUP_TEXT](name: string) {
    this.radioGroup = name;
  }

  @Mutation
  public [CHANGE_SLIDER_MODEL_VALUE](value: number) {
    this.sliderModel = value;
  }

  @Mutation
  public [SET_FILTERING_STATE_TO_DEFAULT]() {
    this.sliderElementDisabled = true;
    this.radioGroupElementDisabled = true;
    this.radioGroup = '';
    this.sliderModel = 0;
  }
}
